// import React, { useState,useEffect } from 'react';
// import './contact.css';
// import phone from '../../assets/PhoneCall.svg';
// import email from '../../assets/Email.svg';
// import map from '../../assets/MapPin.svg';
// import { postWithoutTokenAPI } from '../../util/Api';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Map from './Map';
//    import AOS from 'aos';
// import 'aos/dist/aos.css';

// function About() {


// useEffect(() => {
//   AOS.init({ duration: 800, once: true });
// }, []);

//     const [formData, setFormData] = useState({
//         name: '',
//         email: '',
//         subject: '',
//         message: ''
//     });
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [errors, setErrors] = useState({
//         name: '',
//         email: '',
//         subject: '',
//         message: ''
//     });

//     const validateEmail = (email) => {
//         const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         return re.test(email);
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });

//         // Clear error when user starts typing
//         if (errors[name]) {
//             setErrors({ ...errors, [name]: '' });
//         }
//     };

//     const validateForm = () => {
//         const newErrors = {
//             name: '',
//             email: '',
//             subject: '',
//             message: ''
//         };
//         let isValid = true;

//         if (!formData.name.trim()) {
//             newErrors.name = 'Name is required';
//             isValid = false;
//         }

//         if (!formData.email.trim()) {
//             newErrors.email = 'Email is required';
//             isValid = false;
//         } else if (!validateEmail(formData.email)) {
//             newErrors.email = 'Please enter a valid email address';
//             isValid = false;
//         }

//         if (!formData.subject.trim()) {
//             newErrors.subject = 'Subject is required';
//             isValid = false;
//         }

//         if (!formData.message.trim()) {
//             newErrors.message = 'Message is required';
//             isValid = false;
//         }

//         setErrors(newErrors);
//         return isValid;
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!validateForm()) return;

//         setIsSubmitting(true);

//         try {
//             const res = await postWithoutTokenAPI('/contact/create', formData);

//             if (!res.error && res.statusCode === 200) {
//                 toast.success("Enquiry submitted! We'll get back to you soon");
//                 setFormData({ name: '', email: '', subject: '', message: '' });
//             } else {
//                 toast.error(res.message || 'Failed to send message. Please try again');
//             }
//         } catch (err) {
//             toast.error('An error occurred. Please try again later');
//             console.error(err);
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     return (
//         <>
//             {/* <ToastContainer  autoClose={3000} /> */}
//           <div className="contact-section">
//   <div className="contact-infos">
//     <div className="contact-box" data-aos="fade-right" data-aos-delay="100">
//       <div className="contact-icon">
//         <img src={map} alt="map" />
//       </div>
//       <div className="contact-text">
//         2715 Ash Dr. San Jose, South Dakota 83475
//       </div>
//     </div>

//     <div className="contact-divider" data-aos="zoom-in" data-aos-delay="150"></div>

//     <div className="contact-box" data-aos="fade-up" data-aos-delay="200">
//       <div className="contact-icon">
//         <img src={email} alt="email" />
//       </div>
//       <div className="contact-text">
//         Proxy@gmail.com <br /> Help.proxy@gmail.com
//       </div>
//     </div>

//     <div className="contact-divider" data-aos="zoom-in" data-aos-delay="250"></div>

//     <div className="contact-box" data-aos="fade-left" data-aos-delay="300">
//       <div className="contact-icon">
//         <img src={phone} alt="phone" />
//       </div>
//       <div className="contact-text">
//         (219) 555-0114 <br /> (164) 333-0487
//       </div>
//     </div>
//   </div>

//   <div className="say-hello">
//     <h2 data-aos="fade-down" data-aos-delay="100">Just Say Hello!</h2>
//     <p className="description" data-aos="fade-up" data-aos-delay="150">
//       Do you fancy saying hi to me or want to get started with your project and need my help?
//       Feel free to contact me.
//     </p>

//     <form onSubmit={handleSubmit} data-aos="flip-up" data-aos-delay="200">
//       <div className="form-row">
//         <div className="input-group-contact" data-aos="fade-right" data-aos-delay="250">
//           <input
//             type="text"
//             name="name"
//             placeholder="Your Name"
//             className={`highlight ${errors.name ? 'error' : ''}`}
//             value={formData.name}
//             onChange={handleChange}
//           />
//           {errors.name && <span className="error-message">{errors.name}</span>}
//         </div>
//         <div className="input-group-contact" data-aos="fade-left" data-aos-delay="300">
//           <input
//             type="email"
//             name="email"
//             placeholder="Email Address"
//             className={`highlight ${errors.email ? 'error' : ''}`}
//             value={formData.email}
//             onChange={handleChange}
//           />
//           {errors.email && <span className="error-message">{errors.email}</span>}
//         </div>
//       </div>

//       <div className="input-group-contact" data-aos="fade-up" data-aos-delay="350">
//         <input
//           type="text"
//           name="subject"
//           placeholder="Subject"
//           className={`highlight ${errors.subject ? 'error' : ''}`}
//           value={formData.subject}
//           onChange={handleChange}
//         />
//         {errors.subject && <span className="error-message">{errors.subject}</span>}
//       </div>

//       <div className="input-group-contact" data-aos="fade-up" data-aos-delay="400">
//         <textarea
//           name="message"
//           placeholder="Your Message"
//           className={`highlight ${errors.message ? 'error' : ''}`}
//           value={formData.message}
//           onChange={handleChange}
//         ></textarea>
//         {errors.message && <span className="error-message">{errors.message}</span>}
//       </div>

//       <div data-aos="zoom-in" data-aos-delay="500">
//         <button type="submit" disabled={isSubmitting}>
//           {isSubmitting ? 'Sending...' : 'Send Message'}
//         </button>
//       </div>
//     </form>
//   </div>
// </div>

//             {/* <Map />_ */}
//             <iframe
//     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.6005518029538!2d80.20942947412072!3d12.997381314314467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5266fd3f817033%3A0xac91dc7fcbdf20bd!2sDextra%20Technologies%20-%20Website%20Development%20Company%20In%20Chennai%20%7C%20SEO%20%26%20Mobile%20App%20Company%20in%20Chennai!5e0!3m2!1sen!2sin!4v1747311214594!5m2!1sen!2sin%22" 
//     width="100%" 
//     height="450" 
//     style={{ border: 0 }}
//     allowFullScreen="" 
//     loading="lazy" 
//     referrerPolicy="no-referrer-when-downgrade"
// ></iframe>        </>
//     );
// }

// export default About;



import React, { useState, useEffect } from 'react';
import './contact.css';
import phone from '../../assets/PhoneCall.svg';
import email from '../../assets/Email.svg';
import map from '../../assets/MapPin.svg';
import { postWithoutTokenAPI } from '../../util/Api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import TrustSafety from './TrustSafety';
import Swal from 'sweetalert2';


function About() {
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [errors, setErrors] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  useEffect(() => {
    AOS.init({ duration: 800, once: true });

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const validateForm = () => {
    const newErrors = { name: '', email: '', subject: '', message: '' };
    let isValid = true;

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
      isValid = false;
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
      isValid = false;
    }

    if (!formData.subject.trim()) {
      newErrors.subject = 'Subject is required';
      isValid = false;
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      const res = await postWithoutTokenAPI('/contact/create', formData);
      if (!res.error && res.statusCode === 200) {
        await Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: `Enquiry submitted! We'll get back to you soon`,
          timer: 2000, // Auto close after 2 seconds
          showConfirmButton: false,
          toast: true, // Makes it look like a toast
          position: 'top-end',
        });
        // toast.success("Enquiry submitted! We'll get back to you soon");
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        toast.error(res.message || 'Failed to send message. Please try again');
      }
    } catch (err) {
      toast.error('An error occurred. Please try again later');
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <ToastContainer autoClose={3000} />
        <TrustSafety/>
      {isLoading ? (
        <div className="contact-section">
          <div className="contact-infos">
            <div className="skeleton skeleton-box"></div>
            <div className="skeleton skeleton-box"></div>
            <div className="skeleton skeleton-box"></div>
          </div>
          <div className="say-hello">
            <h2 className="skeleton skeleton-text" style={{ width: '40%' }}></h2>
            <p className="skeleton skeleton-text" style={{ width: '80%' }}></p>

            <div className="form-row">
              <div className="input-group-contact skeleton-box skeleton" style={{ width: '48%' }}></div>
              <div className="input-group-contact skeleton-box skeleton" style={{ width: '48%' }}></div>
            </div>
            <div className="input-group-contact skeleton-box skeleton"></div>
            <div className="input-group-contact skeleton-box skeleton" style={{ height: '100px' }}></div>
            <div className="skeleton skeleton-box" style={{ width: '150px', height: '40px' }}></div>
          </div>
        </div>
      ) : (
        <div className="contact-section">
          <div className="contact-infos">
            <div className="contact-box" data-aos="fade-right" data-aos-delay="100">
              <div className="contact-icon"><img src={map} alt="map" /></div>
              <div className="contact-text">1st Floor, Aqua Mall, Door #1A, Plot #1, Cart Track Rd, Velachery, Chennai, Tamil Nadu 600032</div>
            </div>
            <div className="contact-divider" data-aos="zoom-in" data-aos-delay="150"></div>
            <div className="contact-box" data-aos="fade-up" data-aos-delay="200">
              <div className="contact-icon"><img src={email} alt="email" /></div>
              <div className="contact-text">info@dextratechnologies.com</div>
            </div>
            <div className="contact-divider" data-aos="zoom-in" data-aos-delay="250"></div>
            <div className="contact-box" data-aos="fade-left" data-aos-delay="300">
              <div className="contact-icon"><img src={phone} alt="phone" /></div>
              <div className="contact-text">+91 4448648848</div>
            </div>
          </div>

          <div className="say-hello">
            <h2 data-aos="fade-down" data-aos-delay="100">Just Say Hello!</h2>
            <p className="description" data-aos="fade-up" data-aos-delay="150">
              Do you fancy saying hi to me or want to get started with your project and need my help?
              Feel free to contact me.
            </p>

            <form onSubmit={handleSubmit} data-aos="flip-up" data-aos-delay="200">
              <div className="form-row">
                <div className="input-group-contact" data-aos="fade-right" data-aos-delay="250">
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    className={`highlight ${errors.name ? 'error' : ''}`}
                    value={formData.name}
                    onChange={handleChange}
                  />
                  {errors.name && <span className="error-message">{errors.name}</span>}
                </div>
                <div className="input-group-contact" data-aos="fade-left" data-aos-delay="300">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    className={`highlight ${errors.email ? 'error' : ''}`}
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>
              </div>

              <div className="input-group-contact" data-aos="fade-up" data-aos-delay="350">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  className={`highlight ${errors.subject ? 'error' : ''}`}
                  value={formData.subject}
                  onChange={handleChange}
                />
                {errors.subject && <span className="error-message">{errors.subject}</span>}
              </div>

              <div className="input-group-contact" data-aos="fade-up" data-aos-delay="400">
                <textarea
                  name="message"
                  placeholder="Your Message"
                  className={`highlight ${errors.message ? 'error' : ''}`}
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
                {errors.message && <span className="error-message">{errors.message}</span>}
              </div>

              <div data-aos="zoom-in" data-aos-delay="500">
                <button type="submit" disabled={isSubmitting}>
                  {isSubmitting ? <span className="spinner"></span> : 'Send Message'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div style={{ width: "100%", height: "450px", margin: "auto" }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.6891234567!2d80.2207!3d12.9716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d9f9f9f9f9f%3A0x1234567890abcdef!2sAqua%20Mall%2C%20Velachery%2C%20Chennai!5e0!3m2!1sen!2sin!4v1234567890123"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade">
        </iframe>
      </div>
    </>
  );
}

export default About;
